export default __webpack_public_path__ + "static/media/lock.6c011d7c.svg";